module.exports = __webpack_public_path__ + "img/证书2.513876a9.jpg";